import { useCallback, useRef, useEffect } from 'react';

const useSticky = (gridHeight: number) => {
  const headerElementRef = useRef<any>();
  const topRowElementRef = useRef<any>();
  const bodyElementRef = useRef<any>();
  const scrollHorizontalElementRef = useRef<any>();
  const paginateElementRef = useRef<any>();
  const compareElementRef = useRef<any>();
  const compareBtnRef = useRef<any>();
  const addToListElementRef = useRef<any>();
  const addProductsAlternateToListElementRef = useRef<any>();
  const stickyRef = useRef<boolean>(false);
  const originalStyles = useRef<any>({ position: '', top: '', zIndex: '' });

  const onScroll = useCallback(() => {
    const header = headerElementRef.current;
    const topRow = topRowElementRef.current;
    const body = bodyElementRef.current;
    const scrollHorizontal = scrollHorizontalElementRef.current;
    const scrollHorizontalY = window.innerHeight;

    let bodyWidth;
    let shouldStick = false;
    let shouldUnstick = false;
    let shouldscrollHorizontalUnstick = false;
    if (header && topRow && body) {
      bodyWidth = body.getBoundingClientRect().width;
      if (!stickyRef.current) {
        shouldStick =
          header.getBoundingClientRect().top +
            topRow.getBoundingClientRect().top <=
          0;
        if (shouldStick) stickyRef.current = true;
      } else {
        shouldUnstick =
          body.getBoundingClientRect().top -
            header.getBoundingClientRect().height +
            topRow.getBoundingClientRect().height >
          0;
        if (shouldUnstick) stickyRef.current = false;
      }

      if (body.getBoundingClientRect().bottom < scrollHorizontalY) {
        shouldscrollHorizontalUnstick = true;
      }
      if (body.getBoundingClientRect().bottom < 50) {
        shouldUnstick = true;
      }

      if (shouldStick) {
        header.style.position = 'fixed';
        header.style.top = '0';
        // this is optional, but if you have other contents that overlap the
        // header you may want to adjust zIndex accordingly
        header.style.zIndex = '2';
        header.style.width = `${bodyWidth}px`;

        topRow.style.position = 'fixed';
        topRow.style.top = `${header.clientHeight}px`;
        topRow.style.zIndex = '2';
        topRow.style.width = `${bodyWidth}px`;

        body.style.height = '100%';
      }
      if (shouldUnstick) {
        const original = originalStyles.current;
        header.style.position = original.position;
        header.style.top = original.top;
        header.style.zIndex = original.zIndex;
        header.style.width = '100%';

        topRow.style.position = original.position;
        topRow.style.top = original.top;
        topRow.style.zIndex = original.zIndex;
        topRow.style.width = '100%';
      }
    }
    if (scrollHorizontal) {
      if (shouldscrollHorizontalUnstick) {
        scrollHorizontal.style.position = 'unset';
        scrollHorizontal.style.width = '100%';
      } else {
        scrollHorizontal.style.position = 'fixed';
        scrollHorizontal.style.bottom = '0';
        scrollHorizontal.style.zIndex = '1';
        scrollHorizontal.style.width = `${bodyWidth}px`;
      }
    }
  }, []);

  const setFixed = () => {
    const floatingDiv = document.querySelectorAll(
      '.selected-buttons-wrapper'
    )[0];
    const selectedFloater = document.querySelectorAll(
      '.selected-buttons-floater'
    )[0];
    const footer = document.querySelectorAll('#footer')[0];
    compareBtnRef.current = document.querySelector('[id="compare-btn"]');
    let addToListBtn = document.querySelector('[id="add-to-list-button"]');
    let addProductAlternateToListBtn = document.querySelector('[id="add-product-alternate-to-list-button"]');

    if (floatingDiv) {
      if (compareBtnRef.current || addToListBtn || addProductAlternateToListBtn) {
        floatingDiv.classList.remove('hidden');
      } else {
        floatingDiv.classList.add('hidden');
      }
    }
    if (selectedFloater) {
      if (checkVisible(floatingDiv) || checkVisible(footer)) {
        selectedFloater.classList.remove('fixed-floater');
      } else {
        selectedFloater.classList.add('fixed-floater');
      }
    }
  };

  const checkVisible = (elm: { getBoundingClientRect: () => any }) => {
    if (elm) {
      const rect = elm.getBoundingClientRect();
      const viewHeight = Math.max(
        document.documentElement.clientHeight,
        window.innerHeight
      );
      return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
    }

    return false;
  };

  const checkSticky = () => {
    headerElementRef.current = document.querySelector('[ref="gridHeader"]');
    topRowElementRef.current = document.querySelector('[ref="eTop"]');
    bodyElementRef.current = document.querySelector('[ref="eBodyViewport"]');
    scrollHorizontalElementRef.current = document.querySelector(
      '[class="ag-body-horizontal-scroll"]'
    );
    paginateElementRef.current = document.querySelector(
      '[class="ag-paging-panel ag-unselectable"]'
    );
    compareElementRef.current = document.querySelector('[id="compare-button"]');
    addToListElementRef.current = document.querySelector(
      '[id="add-to-list-container"]'
    );
    addProductsAlternateToListElementRef.current = document.querySelector(
      '[id="add-products-alternate-to-list-container"]'
    );

    const topRow = topRowElementRef.current;
    const header = headerElementRef.current;
    const body = bodyElementRef.current;
    const scrollHorizontal = scrollHorizontalElementRef.current;
    const compareButton = compareElementRef.current;
    const addToListButton = addToListElementRef.current;
    const addProductsAlternateToListButton = addProductsAlternateToListElementRef.current;
    let bodyWidth;

    const scrollHorizontalY = window.innerHeight;
    let shouldscrollHorizontalUnstick = false;

    if (body) {
      bodyWidth = body.getBoundingClientRect().width;
    }

    if (body && body.getBoundingClientRect().bottom < scrollHorizontalY) {
      shouldscrollHorizontalUnstick = true;
    }

    if (body && body.getBoundingClientRect().bottom > 900) {
      shouldscrollHorizontalUnstick = false;
    }

    if (header) {
      originalStyles.current.position = header.style.position;
      originalStyles.current.top = header.style.top;
      originalStyles.current.zIndex = header.style.zIndex;
    }

    if (topRow) {
      originalStyles.current.position = topRow.style.position;
      originalStyles.current.top = topRow.style.top;
      originalStyles.current.zIndex = topRow.style.zIndex;
    }

    if (scrollHorizontal) {
      scrollHorizontal.style.position = shouldscrollHorizontalUnstick
        ? 'unset'
        : 'fixed';
      scrollHorizontal.style.bottom = '0';
      scrollHorizontal.style.zIndex = '1';
      scrollHorizontal.style.width = shouldscrollHorizontalUnstick
        ? '100%'
        : `${bodyWidth}px`;
    }

    if (stickyRef.current) {
      originalStyles.current.position = '';
      originalStyles.current.top = '';
      originalStyles.current.zIndex = '';
    }

    if (compareButton || addToListButton || addProductsAlternateToListButton) {
      setFixed();
    }
  };

  useEffect(() => {
    checkSticky();
  });

  useEffect(() => {
    checkSticky();
  }, [gridHeight]);

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, [onScroll]);

  return stickyRef;
};

export default useSticky;
